import * as gridSettings from '@/app/gridGL/pixiApp/gridSettings';

const isAIAnalystFocused = (): boolean => {
  return document.activeElement?.closest('[data-ai-analyst-panel]') !== null;
};

export const focusGrid = () => {
  // Don't steal focus from AI Analyst panel
  if (isAIAnalystFocused()) {
    return;
  }

  // Don't steal focus from inline editor
  if (gridSettings.getInput().show) {
    return;
  }

  const editorInteractionState = gridSettings.getEditorInteractionState();
  const modalShow =
    editorInteractionState.showCellTypeMenu ||
    editorInteractionState.showCommandPalette ||
    editorInteractionState.showConnectionsMenu ||
    editorInteractionState.showGoToMenu ||
    editorInteractionState.showFeedbackMenu ||
    editorInteractionState.showRenameFileMenu ||
    editorInteractionState.showShareFileMenu ||
    editorInteractionState.showSearch ||
    editorInteractionState.showContextMenu;
  if (modalShow) {
    return;
  }

  // Set focus back to Grid
  const grid = document.querySelector<HTMLCanvasElement>('.pixi_canvas');
  if (grid) {
    grid.focus();
  }
};

export const focusAIAnalyst = () => {
  const textarea = document.querySelector<HTMLTextAreaElement>('[data-ai-analyst-input]');
  if (textarea) {
    textarea.focus();
    return;
  }

  // Element not yet in DOM — poll using rAF with a timeout
  const maxWaitMs = 2000;
  const start = performance.now();

  const poll = () => {
    const el = document.querySelector<HTMLTextAreaElement>('[data-ai-analyst-input]');
    if (el) {
      el.focus();
      return;
    }
    if (performance.now() - start < maxWaitMs) {
      requestAnimationFrame(poll);
    }
  };

  requestAnimationFrame(poll);
};
